import UserAddresses from './UserAddresses';

export default UserAddresses;
